export function fixBody(fix: boolean) {
  document.body.style.overflow = fix ? "hidden" : "visible";
}
